import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { ReactComponent as Doc } from "../assets/DocumentTypeIconDoc.svg";
import { ReactComponent as Docx } from "../assets/DocumentTypeIconDocx.svg";
import { ReactComponent as Jpg } from "../assets/DocumentTypeIconJpg.svg";
import { ReactComponent as Pdf } from "../assets/DocumentTypeIconPdf.svg";
import { ReactComponent as Png } from "../assets/DocumentTypeIconPng.svg";
import { ReactComponent as Xlsx } from "../assets/DocumentTypeIconXlsx.svg";
import { ReactComponent as Xls } from "../assets/DocumentTypeIconXls.svg";

function DocumentType(props) {
  const documentTypes = {
    doc: {icon: Doc, color: "#297fff"},
    docx: {icon: Docx, color: "#165ABC"},
    jpg: {icon: Jpg, color: "#e28500"},
    pdf: {icon: Pdf, color: "#dc1e00"},
    png: {icon: Png, color: "#2fbc9a"},
    xls: {icon: Xls, color: "#2fbc9a"},
    xlsx: {icon: Xlsx, color: "#2fbc9a"},
  };

  const renderIcon = (props) => {
    if (typeof documentTypes[props.filetype] !== "undefined") {
      return React.createElement(documentTypes[props.filetype].icon, {style: {color: documentTypes[props.filetype].color, ...props.style} });
    }
    // component doesn't exist yet
    return <></>
  }

  const icon = renderIcon(props);
  const style = {};

  return (
    <SvgIcon {...props} viewBox="0 0 32 32">
      {icon}
    </SvgIcon>
  );
}

export default DocumentType;
